module.exports = __webpack_public_path__ + "img/add_bg_img.1586007e.svg";